// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__kcmlA","loadingphase":"Loader_loadingphase__sbs+j","spin":"Loader_spin__IcERB"};